// Accounting › Fixed assets — Depreciation tab (prefix aw_fad_). Batch 9 R4: COA-H8 (the nine columns,
// Calculate before Post), COA-H10 (the run history and its reversal), COA-H12 (the sheet), COA-H15
// (the company's charging frequency), COA-H10.3 (Reverse & recalculate from the run history). The tab
// name and the six statuses are facommon's (aw_fa_*).
// Rules (as every mt package): no _plural keys; numbers as {{n}}; no empty value in any language.
export const en: Record<string, string> = {
  aw_fad_view_label: 'Depreciation views',
  aw_fad_view_table: 'Depreciation table',
  aw_fad_view_history: 'Run history',
  aw_fad_period: 'Accounting period {{from}} – {{to}}',
  aw_fad_freq_label: 'Charged (company setting)',
  aw_fad_freq_title: 'How often this company charges depreciation. It is the company\'s setting, not a view of this table: it applies to every asset, and it cannot be changed once an open period carries charges.',
  aw_fad_freq_annual: 'Once per accounting period',
  aw_fad_freq_monthly: 'Monthly',
  aw_fad_freq_unknown: '— read when you calculate',
  aw_fad_freq_is: 'Charged: {{freq}} (company setting)',
  aw_fad_month: 'Month',
  aw_fad_month_needed: 'This company charges depreciation monthly — choose the month to calculate.',
  aw_fad_calc: 'Calculate depreciation',
  aw_fad_calc_title: 'Preview what this window would be charged. Nothing is written.',
  aw_fad_calc_prompt: 'Nothing has been calculated yet. Press "Calculate depreciation" to preview the charge before anything is posted.',
  aw_fad_calculated_at: 'Calculated {{at}} · {{window}}',
  aw_fad_stat_assets: 'Total assets',
  aw_fad_stat_period: 'Depreciation for the period',
  aw_fad_stat_nbv: 'New total book value',
  aw_fad_col_no: 'Asset No.',
  aw_fad_col_name: 'Asset name',
  aw_fad_col_category: 'Asset category',
  aw_fad_col_cost: 'Acquisition cost',
  aw_fad_col_rate: 'Rate / useful life',
  aw_fad_col_opening: 'Opening accumulated depreciation',
  aw_fad_col_period: 'Depreciation for the period',
  aw_fad_col_closing: 'Closing accumulated depreciation',
  aw_fad_col_nbv: 'Closing net book value',
  aw_fad_rate_life: '{{rate}}% · {{life}} y',
  aw_fad_no_category: 'No category',
  aw_fad_group_count: '{{n}} asset(s)',
  aw_fad_fold: 'Collapse {{name}}',
  aw_fad_unfold: 'Expand {{name}}',
  aw_fad_total: 'Total ({{n}})',
  aw_fad_days_title: '{{n}} day(s), {{from}} – {{to}}',
  aw_fad_skip_not_depreciable: 'Not depreciated — its class is never charged',
  aw_fad_skip_no_accounts: 'Not charged — no depreciation accounts are set',
  aw_fad_skip_not_owned: 'Not held in this window',
  aw_fad_skip_already_charged: 'Already charged in this window',
  aw_fad_skip_fully_depreciated: 'Fully depreciated — nothing left to charge',
  aw_fad_skip_not_available: 'Not yet in use — not charged',
  aw_fad_skip_other: 'Not charged',
  aw_fad_excel: 'Download as Excel',
  aw_fad_excel_title: 'This table as a spreadsheet: the nine columns, the category subtotals and the total.',
  aw_fad_post: 'Post depreciation · {{amount}}',
  aw_fad_post_title: 'Makes ONE draft journal entry for the charge shown; it is posted under Accounting › Journal entries.',
  aw_fad_post_confirm: 'Post depreciation of {{amount}} on {{n}} asset(s) for {{window}}?\n\nThis makes a DRAFT journal entry (Dr depreciation expense / Cr accumulated depreciation). It reaches the ledger only when it is posted under Accounting › Journal entries.',
  aw_fad_posted: 'Draft {{no}} made: {{amount}} on {{n}} asset(s). Post it under Accounting › Journal entries.',
  aw_fad_posted_none: 'Nothing was charged — {{n}} asset(s) already carry a charge for this window.',
  aw_fad_open_journal: 'Open Journal entries',
  aw_fad_none: 'No asset is held in this window.',
  aw_fad_hist_col_doc: 'Doc no.',
  aw_fad_hist_col_window: 'Window',
  aw_fad_hist_col_assets: 'Assets',
  aw_fad_hist_col_amount: 'Amount',
  aw_fad_hist_col_status: 'Status',
  aw_fad_hist_col_reversal: 'Reversal',
  aw_fad_status_draft: 'Draft',
  aw_fad_status_posted: 'Posted',
  aw_fad_reversed_by: 'Reversed by {{no}} ({{status}})',
  aw_fad_window_to: 'to {{to}}',
  aw_fad_hist_none: 'No depreciation has been run in this period.',
  aw_fad_hist_note: 'A run is never edited or deleted: it is taken back by a reversal entry. Once the reversal is posted, the charge comes off the asset register and the window can be calculated and charged again.',
  aw_fad_open_entry: 'Open the journal entry {{no}}',
  aw_fad_reverse: 'Reverse & recalculate',
  aw_fad_reverse_title: 'Make a reversal entry for this run and post it (that takes its charge back off the asset register), then calculate the window again.',
  aw_fad_reverse_confirm: 'Reverse {{no}}?\n\nA reversal entry will be made and posted now. Posting it takes this run\'s charge back off the asset register, so the window can be calculated and charged again. {{no}} itself stays in the books beside its reversal.',
  aw_fad_reverse_confirm_draft: 'Post {{rv}}, the reversal of {{no}}?\n\nPosting it takes this run\'s charge back off the asset register, so the window can be calculated and charged again.',
  aw_fad_reversed_done: '{{no}} was reversed by {{rv}} (posted). Its charge is off the register, and the window has been calculated again below.',
  aw_fad_reverse_refused_closed: 'Cannot be reversed: {{no}} was posted in a closed period ({{from}} – {{to}}). Correct it with an entry in the open period instead.',
  aw_fad_reverse_refused_disposed: 'Cannot be reversed yet: asset {{asset}} was disposed of by {{doc}}, which counts this charge. Reverse {{doc}} first.',
  aw_fad_reverse_refused_disposal_draft: 'Cannot be reversed yet: asset {{asset}} has a draft disposal, {{doc}}, that counts this charge. Discard that draft first.',
  aw_fad_reverse_refused: 'This run cannot be reversed as the books stand.',
};
export const zh: Record<string, string> = {
  aw_fad_view_label: '折旧视图',
  aw_fad_view_table: '折旧表',
  aw_fad_view_history: '计提记录',
  aw_fad_period: '会计期间 {{from}} – {{to}}',
  aw_fad_freq_label: '计提频率（公司设置）',
  aw_fad_freq_title: '本公司计提折旧的频率。这是公司的设置，不是本表的视图：适用于所有资产；一旦开放期间内已有计提，便不能再更改。',
  aw_fad_freq_annual: '每个会计期间一次',
  aw_fad_freq_monthly: '按月',
  aw_fad_freq_unknown: '— 计算时读取',
  aw_fad_freq_is: '计提频率：{{freq}}（公司设置）',
  aw_fad_month: '月份',
  aw_fad_month_needed: '本公司按月计提折旧——请选择要计算的月份。',
  aw_fad_calc: '计算折旧',
  aw_fad_calc_title: '预览本期间将计提的金额，不写入任何数据。',
  aw_fad_calc_prompt: '尚未计算。点击"计算折旧"可在过账前预览计提金额。',
  aw_fad_calculated_at: '计算于 {{at}} · {{window}}',
  aw_fad_stat_assets: '资产总数',
  aw_fad_stat_period: '本期折旧',
  aw_fad_stat_nbv: '新账面价值合计',
  aw_fad_col_no: '资产编号',
  aw_fad_col_name: '资产名称',
  aw_fad_col_category: '资产类别',
  aw_fad_col_cost: '购置成本',
  aw_fad_col_rate: '折旧率 / 使用年限',
  aw_fad_col_opening: '期初累计折旧',
  aw_fad_col_period: '本期折旧额',
  aw_fad_col_closing: '期末累计折旧',
  aw_fad_col_nbv: '期末账面净值',
  aw_fad_rate_life: '{{rate}}% · {{life}} 年',
  aw_fad_no_category: '无类别',
  aw_fad_group_count: '{{n}} 项资产',
  aw_fad_fold: '收起 {{name}}',
  aw_fad_unfold: '展开 {{name}}',
  aw_fad_total: '合计（{{n}}）',
  aw_fad_days_title: '{{n}} 天，{{from}} – {{to}}',
  aw_fad_skip_not_depreciable: '不计提——该类别不折旧',
  aw_fad_skip_no_accounts: '未计提——未设置折旧科目',
  aw_fad_skip_not_owned: '本期间内未持有',
  aw_fad_skip_already_charged: '本期间已计提',
  aw_fad_skip_fully_depreciated: '已提足折旧——无可计提',
  aw_fad_skip_not_available: '尚未投入使用——不计提',
  aw_fad_skip_other: '未计提',
  aw_fad_excel: '下载 Excel',
  aw_fad_excel_title: '将本表导出为电子表格：九列、类别小计和合计。',
  aw_fad_post: '过账折旧 · {{amount}}',
  aw_fad_post_title: '为所示金额生成一张草稿凭证；在"会计 › 记账凭证"中过账。',
  aw_fad_post_confirm: '为 {{n}} 项资产过账 {{window}} 的折旧 {{amount}}？\n\n这会生成一张草稿凭证（借：折旧费用 / 贷：累计折旧）。只有在"会计 › 记账凭证"中过账后才会进入总账。',
  aw_fad_posted: '已生成草稿 {{no}}：{{n}} 项资产，{{amount}}。请在"会计 › 记账凭证"中过账。',
  aw_fad_posted_none: '未计提任何金额——{{n}} 项资产在本期间已计提。',
  aw_fad_open_journal: '打开记账凭证',
  aw_fad_none: '本期间内没有持有的资产。',
  aw_fad_hist_col_doc: '凭证号',
  aw_fad_hist_col_window: '期间',
  aw_fad_hist_col_assets: '资产数',
  aw_fad_hist_col_amount: '金额',
  aw_fad_hist_col_status: '状态',
  aw_fad_hist_col_reversal: '冲销',
  aw_fad_status_draft: '草稿',
  aw_fad_status_posted: '已过账',
  aw_fad_reversed_by: '已由 {{no}} 冲销（{{status}}）',
  aw_fad_window_to: '至 {{to}}',
  aw_fad_hist_none: '本期间尚未计提折旧。',
  aw_fad_hist_note: '计提凭证不能修改或删除，只能通过冲销凭证撤回。冲销凭证过账后，计提会从资产登记簿中撤回，该期间即可重新计算并计提。',
  aw_fad_open_entry: '打开凭证 {{no}}',
  aw_fad_reverse: '冲销并重新计算',
  aw_fad_reverse_title: '为该次计提生成冲销凭证并立即过账（计提随之从资产登记簿撤回），然后重新计算该期间。',
  aw_fad_reverse_confirm: '冲销 {{no}}？\n\n将生成一张冲销凭证并立即过账。过账后，该次计提会从资产登记簿中撤回，该期间即可重新计算并计提。{{no}} 本身仍保留在账簿中，与其冲销凭证并列。',
  aw_fad_reverse_confirm_draft: '将 {{rv}}（{{no}} 的冲销凭证）过账？\n\n过账后，该次计提会从资产登记簿中撤回，该期间即可重新计算并计提。',
  aw_fad_reversed_done: '{{no}} 已由 {{rv}} 冲销（已过账）。其计提已从登记簿撤回，下方已重新计算该期间。',
  aw_fad_reverse_refused_closed: '不能冲销：{{no}} 过账于已结账的会计期间（{{from}} – {{to}}）。请改为在当前开放期间以分录更正。',
  aw_fad_reverse_refused_disposed: '暂不能冲销：资产 {{asset}} 已由 {{doc}} 处置，该处置已计入本次计提。请先冲销 {{doc}}。',
  aw_fad_reverse_refused_disposal_draft: '暂不能冲销：资产 {{asset}} 有一张处置草稿 {{doc}}，已计入本次计提。请先作废该草稿。',
  aw_fad_reverse_refused: '按账簿目前的状态，该次计提不能冲销。',
};
export const th: Record<string, string> = {
  aw_fad_view_label: 'มุมมองค่าเสื่อมราคา',
  aw_fad_view_table: 'ตารางค่าเสื่อมราคา',
  aw_fad_view_history: 'ประวัติการคิดค่าเสื่อม',
  aw_fad_period: 'รอบบัญชี {{from}} – {{to}}',
  aw_fad_freq_label: 'ความถี่การคิดค่าเสื่อม (ตั้งค่าของบริษัท)',
  aw_fad_freq_title: 'ความถี่ที่บริษัทนี้คิดค่าเสื่อมราคา เป็นการตั้งค่าของบริษัท ไม่ใช่มุมมองของตารางนี้ ใช้กับสินทรัพย์ทุกรายการ และเปลี่ยนไม่ได้เมื่อรอบบัญชีที่เปิดอยู่มีการคิดค่าเสื่อมแล้ว',
  aw_fad_freq_annual: 'ครั้งเดียวต่อรอบบัญชี',
  aw_fad_freq_monthly: 'รายเดือน',
  aw_fad_freq_unknown: '— ทราบเมื่อกดคำนวณ',
  aw_fad_freq_is: 'คิดค่าเสื่อม: {{freq}} (ตั้งค่าของบริษัท)',
  aw_fad_month: 'เดือน',
  aw_fad_month_needed: 'บริษัทนี้คิดค่าเสื่อมราคารายเดือน — เลือกเดือนที่จะคำนวณ',
  aw_fad_calc: 'คำนวณค่าเสื่อมราคา',
  aw_fad_calc_title: 'ดูตัวอย่างค่าเสื่อมที่จะคิดในช่วงนี้ ไม่มีการบันทึกใด ๆ',
  aw_fad_calc_prompt: 'ยังไม่ได้คำนวณ กด "คำนวณค่าเสื่อมราคา" เพื่อดูตัวอย่างก่อนบันทึกบัญชี',
  aw_fad_calculated_at: 'คำนวณเมื่อ {{at}} · {{window}}',
  aw_fad_stat_assets: 'จำนวนสินทรัพย์',
  aw_fad_stat_period: 'ค่าเสื่อมราคางวดนี้',
  aw_fad_stat_nbv: 'มูลค่าตามบัญชีรวมใหม่',
  aw_fad_col_no: 'เลขที่สินทรัพย์',
  aw_fad_col_name: 'ชื่อสินทรัพย์',
  aw_fad_col_category: 'หมวดสินทรัพย์',
  aw_fad_col_cost: 'ราคาทุน',
  aw_fad_col_rate: 'อัตรา / อายุการใช้งาน',
  aw_fad_col_opening: 'ค่าเสื่อมราคาสะสมต้นงวด',
  aw_fad_col_period: 'ค่าเสื่อมราคาสำหรับงวด',
  aw_fad_col_closing: 'ค่าเสื่อมราคาสะสมปลายงวด',
  aw_fad_col_nbv: 'มูลค่าสุทธิตามบัญชีปลายงวด',
  aw_fad_rate_life: '{{rate}}% · {{life}} ปี',
  aw_fad_no_category: 'ไม่มีหมวด',
  aw_fad_group_count: '{{n}} รายการ',
  aw_fad_fold: 'ยุบ {{name}}',
  aw_fad_unfold: 'ขยาย {{name}}',
  aw_fad_total: 'รวม ({{n}})',
  aw_fad_days_title: '{{n}} วัน, {{from}} – {{to}}',
  aw_fad_skip_not_depreciable: 'ไม่คิดค่าเสื่อม — ประเภทนี้ไม่มีค่าเสื่อมราคา',
  aw_fad_skip_no_accounts: 'ไม่ได้คิด — ยังไม่ได้กำหนดบัญชีค่าเสื่อมราคา',
  aw_fad_skip_not_owned: 'ไม่ได้ถือครองในช่วงนี้',
  aw_fad_skip_already_charged: 'คิดค่าเสื่อมช่วงนี้แล้ว',
  aw_fad_skip_fully_depreciated: 'คิดค่าเสื่อมครบแล้ว — ไม่มีเหลือให้คิด',
  aw_fad_skip_not_available: 'ยังไม่ได้เริ่มใช้งาน — ไม่คิดค่าเสื่อม',
  aw_fad_skip_other: 'ไม่ได้คิดค่าเสื่อม',
  aw_fad_excel: 'ดาวน์โหลดเป็น Excel',
  aw_fad_excel_title: 'ตารางนี้เป็นสเปรดชีต: เก้าคอลัมน์ ยอดรวมย่อยตามหมวด และยอดรวม',
  aw_fad_post: 'บันทึกค่าเสื่อมราคา · {{amount}}',
  aw_fad_post_title: 'สร้างรายการบันทึกบัญชีฉบับร่างหนึ่งรายการสำหรับยอดที่แสดง แล้วผ่านรายการได้ที่ บัญชี › รายการบันทึกบัญชี',
  aw_fad_post_confirm: 'บันทึกค่าเสื่อมราคา {{amount}} ของสินทรัพย์ {{n}} รายการ สำหรับ {{window}} ใช่หรือไม่?\n\nระบบจะสร้างรายการบันทึกบัญชีฉบับร่าง (เดบิต ค่าเสื่อมราคา / เครดิต ค่าเสื่อมราคาสะสม) ซึ่งจะเข้าบัญชีแยกประเภทเมื่อผ่านรายการที่ บัญชี › รายการบันทึกบัญชี เท่านั้น',
  aw_fad_posted: 'สร้างฉบับร่าง {{no}} แล้ว: {{amount}} ของสินทรัพย์ {{n}} รายการ ผ่านรายการได้ที่ บัญชี › รายการบันทึกบัญชี',
  aw_fad_posted_none: 'ไม่มีการคิดค่าเสื่อม — สินทรัพย์ {{n}} รายการคิดค่าเสื่อมช่วงนี้แล้ว',
  aw_fad_open_journal: 'เปิดรายการบันทึกบัญชี',
  aw_fad_none: 'ไม่มีสินทรัพย์ที่ถือครองในช่วงนี้',
  aw_fad_hist_col_doc: 'เลขที่เอกสาร',
  aw_fad_hist_col_window: 'ช่วงเวลา',
  aw_fad_hist_col_assets: 'สินทรัพย์',
  aw_fad_hist_col_amount: 'จำนวนเงิน',
  aw_fad_hist_col_status: 'สถานะ',
  aw_fad_hist_col_reversal: 'การกลับรายการ',
  aw_fad_status_draft: 'ฉบับร่าง',
  aw_fad_status_posted: 'ผ่านรายการแล้ว',
  aw_fad_reversed_by: 'กลับรายการโดย {{no}} ({{status}})',
  aw_fad_window_to: 'ถึง {{to}}',
  aw_fad_hist_none: 'ยังไม่มีการคิดค่าเสื่อมราคาในรอบบัญชีนี้',
  aw_fad_hist_note: 'การคิดค่าเสื่อมแต่ละครั้งแก้ไขหรือลบไม่ได้ ต้องนำออกด้วยรายการกลับ เมื่อผ่านรายการกลับแล้ว ค่าเสื่อมจะถูกนำออกจากทะเบียนสินทรัพย์ และคำนวณและคิดค่าเสื่อมช่วงนั้นใหม่ได้',
  aw_fad_open_entry: 'เปิดรายการบันทึกบัญชี {{no}}',
  aw_fad_reverse: 'กลับรายการและคำนวณใหม่',
  aw_fad_reverse_title: 'สร้างรายการกลับของการคิดค่าเสื่อมครั้งนี้และผ่านรายการทันที (ค่าเสื่อมจะถูกนำออกจากทะเบียนสินทรัพย์) แล้วคำนวณช่วงนั้นใหม่',
  aw_fad_reverse_confirm: 'กลับรายการ {{no}} ใช่หรือไม่?\n\nระบบจะสร้างรายการกลับและผ่านรายการทันที เมื่อผ่านรายการแล้ว ค่าเสื่อมของครั้งนี้จะถูกนำออกจากทะเบียนสินทรัพย์ และคำนวณและคิดค่าเสื่อมช่วงนั้นใหม่ได้ ส่วน {{no}} ยังคงอยู่ในสมุดบัญชีคู่กับรายการกลับ',
  aw_fad_reverse_confirm_draft: 'ผ่านรายการ {{rv}} ซึ่งเป็นรายการกลับของ {{no}} ใช่หรือไม่?\n\nเมื่อผ่านรายการแล้ว ค่าเสื่อมของครั้งนี้จะถูกนำออกจากทะเบียนสินทรัพย์ และคำนวณและคิดค่าเสื่อมช่วงนั้นใหม่ได้',
  aw_fad_reversed_done: '{{no}} กลับรายการโดย {{rv}} (ผ่านรายการแล้ว) ค่าเสื่อมถูกนำออกจากทะเบียนแล้ว และคำนวณช่วงนั้นใหม่ด้านล่าง',
  aw_fad_reverse_refused_closed: 'กลับรายการไม่ได้: {{no}} ผ่านรายการในรอบบัญชีที่ปิดแล้ว ({{from}} – {{to}}) ให้แก้ไขด้วยรายการในรอบบัญชีที่เปิดอยู่แทน',
  aw_fad_reverse_refused_disposed: 'ยังกลับรายการไม่ได้: สินทรัพย์ {{asset}} ถูกจำหน่ายโดย {{doc}} ซึ่งนับรวมค่าเสื่อมครั้งนี้แล้ว ต้องกลับรายการ {{doc}} ก่อน',
  aw_fad_reverse_refused_disposal_draft: 'ยังกลับรายการไม่ได้: สินทรัพย์ {{asset}} มีฉบับร่างรายการจำหน่าย {{doc}} ที่นับรวมค่าเสื่อมครั้งนี้แล้ว ต้องยกเลิกฉบับร่างนั้นก่อน',
  aw_fad_reverse_refused: 'การคิดค่าเสื่อมครั้งนี้กลับรายการไม่ได้ตามสถานะของสมุดบัญชีในขณะนี้',
};
